<form [formGroup]="systemicForm">
	<div class="header-class">
		<h3 class="systemic-card-title margin-bottom-20">Case Details</h3>
	</div>
	<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-20">
		<div fxFlex="39" fxFlex.md="39" fxFlex.sm="100" fxFlex.xs="100">
			<mat-card appearance="outlined" class="full-height">
				<mat-card-content class="margin-left-right-10">
					<div>
						<div class="status-title font-14 margin-bottom-10" id="selSysModType">Select Systemic Module Type</div>
						<mat-radio-group color="primary" formControlName="status" aria-labelledby="selSysModType" ngDefaultControl>
              <ng-container *ngFor="let status of statusArray; let i=index">
							<mat-radio-button
								*ngIf="showWatchList || status.code!='WL'"
								(change)="isChanged()"
								[value]="status.code"
								class="margin-right-30"
								[disabled]="enableSystemicInvestigation && status.code !== enableSystemicInvestigation"
							>
								Systemic {{ status?.description }}

								<mat-icon
									inline
									*ngIf="status?.code != 'WL'"
									[matTooltip]="invesigationInfoMessage"
									[appAnnounceTooltip]="invesigationInfoMessage"
									id="sh-ed-sys-cs-{{ i }}"
									color="primary"
									tabindex="0"
									attr.aria-label="Tooltip. {{ invesigationInfoMessage }}"
									role="none"
									>info</mat-icon
								>
								<mat-icon
									inline
									*ngIf="status?.code == 'WL'"
									id="sh-ed-sys-cs-{{ i }}"
									[matTooltip]="watchCaseInfoMessage"
									[appAnnounceTooltip]="watchCaseInfoMessage"
									color="primary"
									tabindex="0"
									attr.aria-label="Tooltip. {{ watchCaseInfoMessage }}"
									role="none"
									>info</mat-icon
								>
							</mat-radio-button>
            </ng-container>
						</mat-radio-group>
					</div>
					<div class="margin-top-10">
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Systemic Investigation Name</mat-label>
							<input
								matInput
								placeholder="Enter Systemic Investigation Name"
								formControlName="caseName"
								id="case-name"
								[maxLength]="50"
								required
								(keyup)="isChanged()"
							/>
							<mat-error *ngIf="systemicForm.get('caseName').invalid && systemicForm.get('caseName').touched">
								You must enter a systemic investigation name
							</mat-error>
						</mat-form-field>
					</div>
					<!-- <div>
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Systemic Type</mat-label>
							<mat-select placeholder="Select Systemic Type" formControlName="type" id="systemic-type">
								<mat-option *ngFor="let type of typeArray" [value]="type.code">
									{{ type.description }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div> -->
					<div>
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Case Owner</mat-label>
							<input
								type="text"
								matInput
								placeholder="Select Case Owner"
								formControlName="ownerId"
								id="case-owner"
								[matAutocomplete]="auto0"
								required
								(keyup)="isChanged()"
							/>
							<mat-error *ngIf="systemicForm.get('ownerId').invalid && systemicForm.get('ownerId').touched">
								You must enter a case owner
							</mat-error>
						</mat-form-field>
						<mat-autocomplete #auto0="matAutocomplete" [panelWidth]="auto0" [displayWith]="displayFn">
							<mat-option *ngIf="staffArrayLoading" [disabled]="true">
								<mat-spinner diameter="50" color="primary"></mat-spinner>
							</mat-option>
							<ng-container *ngIf="!staffArrayLoading">
								<mat-option *ngFor="let staff of filteredStaffArray" [value]="staff">
									{{ concatName(staff.personName) }}
								</mat-option>
								<mat-option *ngIf="filteredStaffArray?.length === 0" [disabled]="true"> 0 records found. </mat-option>
							</ng-container>
						</mat-autocomplete>
						<div role="status" class="sr-only" aria-live="polite">
							<span *ngIf="!staffArrayLoading">
								There are {{ filteredStaffArray?.length || 0 }} results available.
								<span *ngIf="filteredStaffArray?.length > 0"
									>Use the up and down arrows to navigate between options.</span
								>
							</span>
							<span *ngIf="staffArrayLoading"> Results loading </span>
						</div>
					</div>
					<div class="margin-bottom-10">
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Case Owner Email</mat-label>
							<input
								matInput
								placeholder="Case Owner Email"
								id="case-owner-email"
								[value]="systemicForm?.get('ownerId')?.value?.contactInformation?.emailAddress || 'N/A'"
								readonly
							/>
						</mat-form-field>
					</div>
					<div class="margin-bottom-10">
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Case Owner Office</mat-label>
							<mat-select
								formControlName="officeCode"
								id="sh-ed-sys-cs-officeCode"
								(selectionChange)="enablePreview = true; isChanged()"
                required
								aria-label="Records to Query {{
									systemicForm.get('officeCode').value
										? 'list box with ' +
										  getDescriptionByItemValue(systemicForm.get('officeCode').value, privateOffices) +
										  ' value selected'
										: ''
								}}"
							>
								<mat-option *ngFor="let office of privateOffices" [value]="office.code">
									{{ office.description }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="margin-bottom-10">
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Case Owner Phone</mat-label>
							<input
								matInput
								placeholder="Case Owner Phone"
								id="case-owner-phone"
								[value]="
									systemicForm?.get('ownerId')?.value?.contactInformation?.workPhone ||
									systemicForm?.get('ownerId')?.value?.contactInformation?.cellPhone ||
									systemicForm?.get('ownerId')?.value?.contactInformation?.homePhone ||
									'N/A'
								"
								readonly
							/>
						</mat-form-field>
					</div>
					<div class="margin-bottom-10">
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Description</mat-label>
							<textarea
								matInput
								(keyup)="isChanged()"
								cdkTextareaAutosize
								[maxLength]="5000"
								cdkAutosizeMinRows="5"
								cdkAutosizeMaxRows="5"
								spellcheck="true"
								formControlName="description"
								placeholder="Enter Description.."
								id="description"
							></textarea>
						</mat-form-field>
						<div class="text-right text-area-count">{{ systemicForm.get('description').value?.length || 0 }}/5000</div>
					</div>
					<div class="margin-bottom-10" *ngIf="systemicForm.get('status').value != 'IN'">
						<mat-checkbox
							name="isAutoSearchDisabled"
							id="auto-search-disable"
							formControlName="isAutoSearchDisabled"
							(change)="isChanged()"
						>
							Disable automated search for this investigation.
						</mat-checkbox>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
		<div fxFlex="59" fxFlex.md="59" fxFlex.sm="100" fxFlex.xs="100">
			<mat-card appearance="outlined" class="full-height">
				<mat-card-content class="margin-left-right-10 keyboard-toogle">
					<div class="flex">
						<div>
							<mat-form-field class="width-60" appearance="outline">
								<input
									matInput
									placeholder="Search Notification Recipient"
									[matAutocomplete]="auto1"
									formControlName="notificationRecipientsVOS"
									id="notification-recipients"
								/>
								<mat-hint
									tabindex="0"
									aria-label="Tip, type more characters to narrow your search. Use arrow keys to navigate between result options"
								>
									<strong>Tip: Type more characters to narrow your search.</strong></mat-hint
								>
							</mat-form-field>
							<mat-autocomplete
								#auto1="matAutocomplete"
								[panelWidth]="auto1"
								[displayWith]="displayEmpty"
								(optionSelected)="selectFromAutoComplete($event)"
							>
								<mat-option *ngIf="recipientsLoading" [disabled]="true">
									<mat-spinner diameter="50" color="primary"></mat-spinner>
								</mat-option>
								<ng-container *ngIf="!recipientsLoading">
									<mat-option *ngFor="let user of filteredRecipients" [value]="user">
										<span>{{ concatName(user.personName) }}</span>
									</mat-option>
									<mat-option *ngIf="filteredRecipients?.length === 0" [disabled]="true"> 0 records found. </mat-option>
									<!-- <mat-option *ngIf="this.systemicForm.get('notificationRecipientsVOS')?.value?.length < 2" [disabled]="true">
                                    Enter more letters.
                                </mat-option> -->
								</ng-container>
							</mat-autocomplete>
						</div>
						<div role="status" class="sr-only" aria-live="polite">
							<span *ngIf="!recipientsLoading">
								There are {{ filteredRecipients?.length || 0 }} results available.
								<span *ngIf="filteredRecipients?.length > 0"
									>Use the up and down arrows to navigate between options.</span
								>
							</span>
							<span *ngIf="recipientsLoading"> Results loading </span>
						</div>
						<div class="text-right max-150" *ngIf="systemicData?.systemicDetail?.systemicCase?.systemicCaseId">
							<button
								mat-flat-button
								appDebounceClick
								id="sh-ed-sys-cs-save-btn"
								(debounceClick)="saveCase()"
								[disabled]="!enableSave"
								color="primary"
							>
								SAVE
							</button>
						</div>
					</div>
					<div class="mat-hint font-14">* Case Owners and co-owners are Notification Recipients by default.</div>
					<table mat-table class="margin-top-bottom-10" [dataSource]="recipientsDataSource" matSort appAnnounceSortChange>
						<ng-container matColumnDef="isCoOwner">
							<th mat-header-cell *matHeaderCellDef aria-label="Co Owner">
								<div mat-sort-header sortActionDescription="Sort by co-owner">Co Owner</div>
							</th>
							<td mat-cell *matCellDef="let row">
								<mat-checkbox
									color="primary"
									[(ngModel)]="row.isCoOwner"
									id="sh-ed-sys-{{ row.staffId }}-cs-isChanged"
									(ngModelChange)="isChanged()"
									[ngModelOptions]="{ standalone: true }"
									[disabled]="readonly"
									aria-label="Check this to select this Case Co Owner"
								></mat-checkbox>
							</td>
						</ng-container>

						<ng-container matColumnDef="personName">
							<th mat-header-cell *matHeaderCellDef aria-label="Name">
								<div mat-sort-header sortActionDescription="Sort by name">Name</div>
							</th>
							<!-- This lead column is a th in order to read this column to the user when they are tabbing through the table -->
							<th mat-cell *matCellDef="let row" class="padding-right-5 lead-col mat-mdc-cell">{{ concatName(row.personName) || 'N/A' }}</th>
						</ng-container>

						<ng-container matColumnDef="workPhone">
							<th mat-header-cell *matHeaderCellDef aria-label="Phone">
								<div mat-sort-header sortActionDescription="Sort by phone">Phone</div>
							</th>
							<td mat-cell *matCellDef="let row" class="padding-right-5">
								{{
									row.contactInformation?.workPhone
										? row.contactInformation?.workPhoneExtension
											? row.contactInformation?.workPhone + ' - ' + row.contactInformation?.workPhoneExtension
											: row.contactInformation?.workPhone
										: 'N/A'
								}}
							</td>
						</ng-container>

						<ng-container matColumnDef="emailAddress">
							<th mat-header-cell *matHeaderCellDef aria-label="Email">
								<div mat-sort-header sortActionDescription="Sort by email">Email</div>
							</th>
							<td mat-cell *matCellDef="let row" class="padding-right-5">
								{{ row.contactInformation?.emailAddress || 'N/A' }}
							</td>
						</ng-container>

						<ng-container matColumnDef="officeCode">
							<th mat-header-cell *matHeaderCellDef aria-label="Office Code">
								<div mat-sort-header sortActionDescription="Sort by office code">Office Code</div>
							</th>
							<td mat-cell *matCellDef="let row">{{ row.userOffice?.officeCode || 'N/A' }}</td>
						</ng-container>

						<ng-container matColumnDef="officeName">
							<th mat-header-cell *matHeaderCellDef aria-label="Office Name">
								<div mat-sort-header sortActionDescription="Sort by office name">Office Name</div>
							</th>
							<td mat-cell *matCellDef="let row" class="padding-right-5">{{ row.userOffice?.description || 'N/A' }}</td>
						</ng-container>

						<ng-container matColumnDef="action">
							<th mat-header-cell *matHeaderCellDef aria-label="Action">Action</th>
							<td mat-cell *matCellDef="let row">
								<mat-icon
									color="warn"
									matTooltip="Delete"
									appAnnounceTooltip="Delete"
									appDebounceClick
									(debounceClick)="removeRecepient(row)"
								>cancel
								</mat-icon>
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="recipientsDisplayColumns"></tr>
						<tr class="mat-table-row" mat-row *matRowDef="let row; columns: recipientsDisplayColumns"></tr>
					</table>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
	<div *ngIf="statusCtrl?.value !== 'IN'">
		<div class="header-class">
			<h3 class="systemic-card-title">Setup Query Criteria</h3>
		</div>

		<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-30">
			<div fxFlex="39" fxFlex.md="39" fxFlex.sm="100" fxFlex.xs="100">
				<mat-card appearance="outlined" class="full-height">
					<mat-card-content class="margin-top-10 margin-left-right-10">
						<div class="margin-top-10">
							<mat-form-field class="input-full-width" appearance="outline" formGroupName="caseCriteria">
								<mat-label>Respondent Names</mat-label>
								<input
									matInput
									placeholder="Enter Respondent Names"
									id="sh-ed-sys-cs-respondentNames"
									formControlName="respondents"
									title="Add multiple respondents separated by comma"
									required
									(keyup)="enablePreview = true"
								/>
								<mat-error
									*ngIf="
										systemicForm.get('caseCriteria.respondents').invalid &&
										systemicForm.get('caseCriteria.respondents').touched
									"
								>
									You must enter respondent names
								</mat-error>
							</mat-form-field>
						</div>
						<!-- <div class="margin-bottom-10">OR</div> -->
						<div>
							<mat-form-field class="input-full-width" appearance="outline" formGroupName="caseCriteria">
								<mat-label>EEO-1 HQ Number</mat-label>
								<input
									matInput
									placeholder="Enter EEO-1 HQ Number"
									id="sh-ed-sys-cs-eeo-1HQ-number"
									(keyup)="enablePreview = true"
									formControlName="eeo1HQ"
								/>
							</mat-form-field>
						</div>
						<div>
							<mat-form-field class="input-full-width" appearance="outline" formGroupName="caseCriteria">
								<mat-label>EEO-1 Unit Number</mat-label>
								<input
									matInput
									placeholder="Enter EEO-1 Unit Number"
									id="sh-ed-sys-cs-eeo-EEO-1-unitNumber"
									(keyup)="enablePreview = true"
									formControlName="eeo1Unit"
								/>
							</mat-form-field>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
			<div fxFlex="59" fxFlex.md="59" fxFlex.sm="100" fxFlex.xs="100">
				<mat-card appearance="outlined" class="full-height">
					<mat-card-content class="margin-top-10 margin-left-right-10">
						<div class="margin-top-10">
							<mat-form-field appearance="outline" formGroupName="caseCriteria" class="width-50">
								<mat-label>Records to Query</mat-label>
								<mat-select
									formControlName="status"
									id="sh-ed-sys-cs-status"
									(selectionChange)="enablePreview = true"
									aria-label="Records to Query {{
										systemicForm.get('caseCriteria.status').value
											? 'list box with ' +
											  getDescriptionByItemValue(systemicForm.get('caseCriteria.status').value, RecordsToQueryCodes) +
											  ' value selected'
											: ''
									}}"
								>
									<mat-option *ngFor="let item of RecordsToQueryCodes" [value]="item.value">
										{{ item.description }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div>
							<mat-form-field appearance="outline" formGroupName="caseCriteria" class="width-50">
								<mat-label>Include Closed Records</mat-label>
								<mat-select
									formControlName="closureLookUpDays"
									id="sh-ed-sys-cs-closureLookUpDays"
									(selectionChange)="enablePreview = true"
									aria-label="Include Closed Records {{
										systemicForm.get('caseCriteria.closureLookUpDays').value >= 0
											? 'list box with ' +
											  systemicForm.get('caseCriteria.closureLookUpDays').value +
											  ' days value selected'
											: ''
									}}"
								>
									<mat-option [value]="0"> No Closed Records </mat-option>
									<mat-option [value]="30"> Within 30 days </mat-option>
									<mat-option [value]="60"> Within 60 days </mat-option>
									<mat-option [value]="90"> Within 90 days </mat-option>
									<mat-option [value]="180"> Within 180 days </mat-option>
									<mat-option [value]="365"> Within 1 year </mat-option>
									<mat-option [value]="730"> Within 2 years </mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
		</div>
	</div>
</form>
<div >
	<!-- allegation items -->
	<mat-card appearance="outlined" class="margin-bottom-20">
		<mat-card-content class="margin-top-10 margin-left-right-10">
			<h3 class="arc-h3">Add Systemic Issues</h3>
			<div class="systemic-description margin-bottom-20">
				Select Statute(s), Basis and Issue(s) for applicable allegations. Narrow your options by keyword search.
			</div>
			<div
				fxLayout="row wrap"
				fxLayoutAlign="space-between stretch"
				*ngIf="showSelection"
				class="margin-bottom-20 allegation-selection-container"
			>
				<div fxFlex="32" fxFlex.md="48" fxFlex.sm="100" fxFlex.xs="100" class="full-height">
					<app-shared-allegation-selection
						#statutes
						[header]="'Statutes'"
						[data]="statutesComb"
						[selectedrows]="selectedStatutes || []"
						(selected)="categorySelected($event, 'statute')"
						[readonly]="readonly"
						(init)="
							initStatutesCompleted = $event;
							enablePreview = initBasisesCompleted && initIssusesCompleted && initStatutesCompleted
						"
					>
					</app-shared-allegation-selection>
				</div>
				<div fxFlex="32" fxFlex.md="48" fxFlex.sm="100" fxFlex.xs="100" class="full-height">
					<app-shared-allegation-selection
						[header]="'Basis'"
						[data]="basisComb"
						[selectedrows]="selectedBasises || []"
						(selected)="categorySelected($event, 'basis')"
						[readonly]="readonly"
						(init)="
							initBasisesCompleted = $event;
							enablePreview = initBasisesCompleted && initIssusesCompleted && initStatutesCompleted
						"
					>
					</app-shared-allegation-selection>
				</div>
				<div fxFlex="32" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" class="full-height">
					<app-shared-allegation-selection
						[header]="'Issues'"
						[data]="issueComb"
						[selectedrows]="selectedIssuses || []"
						(selected)="categorySelected($event, 'issue')"
						[readonly]="readonly"
						(init)="
							initIssusesCompleted = $event;
							enablePreview = initBasisesCompleted && initIssusesCompleted && initStatutesCompleted
						"
					>
					</app-shared-allegation-selection>
				</div>
			</div>
			<h4 class="arc-h4 margin-bottom-10">Additional Issues</h4>
			<mat-form-field appearance="outline" [ngStyle]="{ 'width.px': additionalIssuesInputWidth }">
				<mat-label>Type issue and press enter</mat-label>
				<mat-chip-grid #chipList aria-label="additional issues">
					<mat-chip-row
						*ngFor="let issue of additionalIssues; let i = index"
						[removable]="true"
						(removed)="removeAdditionalIssue(i)"
					>
						{{ issue }}
						<mat-icon
							matChipRemove
							matTooltip="Remove Additional Issue"
							appAnnounceTooltip="Remove Additional Issue"
						>close</mat-icon>
					</mat-chip-row>
					<input
						placeholder="Enter Additional Issues"
						id="sh-ed-sys-cs-additionalIssues"
						[matChipInputFor]="chipList"
						[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
						[matChipInputAddOnBlur]="true"
						(matChipInputTokenEnd)="addAdditionalIssue($event)"
						[disabled]="readonly"
					/>
				</mat-chip-grid>
			</mat-form-field>
			<div>
				<span #hiddenTextCalcWidth class="hiddenTextCalcWidth">{{ additionalIssues.join('-----------------') }}</span>
			</div>
		</mat-card-content>
	</mat-card>
</div>
